import { activity } from './activity';
import { enumItems } from './enumItems';
import { driver } from './driver';
import { statuses } from './statuses';
import { group } from './group';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { Activity } from '../types/entities/Activity';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { salesPartner } from './salesPartner';
import { address } from './address';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { userByRole } from './userByRole';
import { ServiceReservation } from '../components/ActivityReservations/ServiceReservation';
import { SPCustomSetFieldForGuideReservation } from '../components/Table/fields/SPCustomSetFieldForGuideReservation';
import { ActivityReservationFinance } from '../components/LegalAndFinance/ActivityReservationFinance';
import { SPListField } from '../components/Table/fields/SPListField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';
import { SelectAddressField } from '../components/Table/fields/SelectAddressField';
import { Finance } from '../components/ActivityReservations/Finance';
import {ServiceReservationView} from "../components/ActivityReservations/ServiceReservationView";
import {SPStatusField} from "../components/Table/fields/SPStatusField";
import {SPSelectVenueAddressField} from "../components/Table/fields/SPSelectVenueAddressField";
import {SPSetUserField} from "../components/Table/fields/SPSetUserField";
import {BooleanField} from "../components/Table/fields/BooleanField";
import {SPBooleanField} from "../components/Table/fields/SPBooleanField";
import {SPSetField} from "../components/Table/fields/SPSetField";
import {user} from "./user";
import {FileField} from "../components/Table/fields/FileField";
import {SingleFileField} from "../components/Table/fields/SingleFileField";

export const activityReservation = (
  forGroupId?: Group['id'],
  forActivityId?: Activity['id']
): SchemaWithClient<any> => {
  return {
    name: 'Activity Reservation',
    pluralName: 'Activity Reservations',
    //treeData: true,
    hasSum: true,
    showDeleted: true,
    tabs: [
      {
        id: 1,
        label: 'General',
        name: 'general',
      },
      {
        id: 2,
        label: 'Reservations',
        name: 'service-reservations',
        type: 'custom',
        renderer: ServiceReservation,
      },
      {
        id: 3,
        label: 'Finance',
        name: 'finance',
        type: 'custom',
        renderer: ActivityReservationFinance,
      },
    ],
    sections: [
      {
        id: 1,
        width: 6,
        label: 'General Data',
        name: 'general',
        grids: [
          {
            width: 12,
            columns: [
              {
                columnName: 'name',
                name: 'Activity Name',
                fieldRenderer: SPTextField,
                readOnly: true,
              },
              {
                columnName: 'type',
                name: 'Type',
                fieldRenderer: SPSelectField.tableAdapter(enumItems.serviceReservationType),
              },
            ],
          },
          {
            width: 6,
            columns: [
              {
                columnName: 'sales_partner',
                name: 'Sales Partner',
                fieldRenderer: SPSelectField.tableAdapter(salesPartner),
              },
              {
                columnName: 'group',
                name: 'Group',
                fieldRenderer: SPSelectField.tableAdapter(enumItems.group),
              },
              {
                columnName: 'date',
                name: 'Date',
                fieldRenderer: SPDateField,
              },
             /* {
                columnName: 'meeting_time',
                name: 'Meeting Time',
                fieldRenderer: SPTimeField,
              },*/
              {
                columnName: 'pickup_time',
                name: 'Pickup Time',
                fieldRenderer: SPTimeField,
              },
              {
                columnName: 'start_time',
                name: 'Start Time',
                fieldRenderer: SPTimeField,
              },
              {
                columnName: 'free',
                name: 'Free Activity',
                fieldRenderer: SPBooleanField,
              },
              {
                columnName: 'refund',
                name: 'Refund',
                fieldRenderer: SPBooleanField,
              },
              {
                columnName: 'guide_bonus',
                name: 'Guide Bonus',
                fieldRenderer: SPBooleanField,
              },
            ],
          },
          {
            width: 6,
            columns: [
              {
                name: 'Guides',
                fieldRenderer: SPCustomSetFieldForGuideReservation.tableAdapter(
                  userByRole('5')
                ),
                columnName: 'guide_reservations',
              },
              {
                columnName: 'group_size',
                name: 'Group Size',
                fieldRenderer: SPNumberField,
              },
              {
                name: 'Meeting Place',
                fieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
                columnName: 'address_from',
              },
              {
                name: 'Venue',
                fieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
                columnName: 'address_to',
              },
              {
                name: 'Notes',
                fieldRenderer: SPRichTextField,
                columnName: 'notes',
              },
              {
                name: 'Date Added',
                fieldRenderer: SPDateTimeField,
                columnName: 'date_added',
                readOnly: true,
              },
              {
                name: 'User Added',
                columnName: 'user_added',
                fieldRenderer: SPSelectField.tableAdapter(enumItems.user),
                readOnly: true,
              },
              {
                columnName: 'confirm_guide_file',
                name: 'Confirm Guide File (SPA activity)',
                fieldRenderer: SingleFileField,
              },
            ],
          },
        ],
      },
      {
        id: 2,
        width: 6,
        label: 'Service Providers',
        name: 'service_providers',
        hasDefaultButtons: true,
        grids: [
          {
            width: 4,
            columns: [
              {
                name: 'Activity',
                fieldRenderer: SPStatusField,
                columnName: 'a_status',
                readOnly: true,
              },
              {
                name: 'Activity Providers',
                fieldRenderer: SPTextField,
                columnName: 'activity_providers',
                readOnly: true,
              },

            ],
          },
          {
            width: 4,
            columns: [
              {
                name: 'Bus',
                fieldRenderer: SPStatusField,
                columnName: 'b_status',
                readOnly: true,
              },
              {
                name: 'Transfer Providers',
                fieldRenderer: SPTextField,
                columnName: 'transfer_providers',
                readOnly: true,
              },


              {
                name: 'Driver',
                fieldRenderer: SPSelectField.tableAdapter(driver),
                columnName: 'driver',
              },
            ],
          },
          {
            width: 4,
            columns: [
              {
                name: 'Staff',
                fieldRenderer: SPStatusField,
                columnName: 's_status',
                readOnly: true,
              },
              {
                name: 'Staff',
                fieldRenderer: SPTextField,
                columnName: 'staff',
                readOnly: true,
              },
            ],
          },
        ],
      },
      {
        id: 3,
        width: 12,
        label: 'Finance',
        name: 'finances',
        grids: [
          {
            width: 6,
            columns: [
              {
                columnName: 'finances',
                fieldRenderer: Finance,
              },
            ],
          },
        ],
      },
      {
        id: 4,
        width: 12,
        label: 'Reservations',
        name: 'reservations',
        grids: [
          {
            width: 12,
            columns: [
              {
                columnName: 'reservations',
                fieldRenderer: ServiceReservationView,
              },
            ],
          },
        ],
      },
    ],
    columns: {
      name: {
        name: 'Name',
        required: false,
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
        readOnly: true,
      },
      type: {
        name: 'Type',
        fieldRenderer: SelectField.tableAdapter(enumItems.serviceReservationType),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.serviceReservationType),
        switchboard: true,
        url: enumItems.serviceReservationType.client.getAllPath,
        tempSchema: enumItems.serviceReservationType,
      },
      activity: {
        name: 'Activity Name',
        required: true,
        fieldRenderer: SelectField.tableAdapter(activity),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(activity),
        switchboard: true,
        url: activity.client.getAllPath,
        tempSchema: activity,
        hideInTableView: true,
      },
      sales_partner: {
        name: 'Sales Partner',
        fieldRenderer: SelectField.tableAdapter(enumItems.salesPartner),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          enumItems.salesPartner
        ),
        switchboard: true,
        required: true,
        url: enumItems.salesPartner.client.getAllPath,
        tempSchema: enumItems.salesPartner,
      },
      date: {
        name: 'Date',
        fieldRenderer: DateField,
        slidePaneFieldRenderer: SPDateField,
        fieldType: 'date',
        required: true,
      },
     /* meeting_time: {
        name: 'Meeting',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
      },*/
      pickup_time: {
        name: 'Pickup',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
      },
      start_time: {
        name: 'Start',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
      },
      a_status: {
        name: 'A',
        fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
          statuses.activityStatus
        ),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          statuses.activityStatus
        ),
        switchboard: true,
        url: statuses.activityStatus.client.getAllPath,
        tempSchema: statuses.activityStatus,
        fieldType: 'clickable-status',
        readOnly: true,
      },
      b_status: {
        name: 'B',
        fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
          statuses.activityStatus
        ),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          statuses.activityStatus
        ),
        switchboard: true,
        url: statuses.activityStatus.client.getAllPath,
        tempSchema: statuses.activityStatus,
        fieldType: 'clickable-status',
        readOnly: true,
      },
      s_status: {
        name: 'S',
        fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
          statuses.activityStatus
        ),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          statuses.activityStatus
        ),
        switchboard: true,
        url: statuses.activityStatus.client.getAllPath,
        tempSchema: statuses.activityStatus,
        fieldType: 'clickable-status',
        readOnly: true,
      },
      group: {
        name: 'Group',
        fieldRenderer: SelectField.tableAdapter(group),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
        switchboard: true,
        readOnly: true,
        url: group.client.getAllPath,
        tempSchema: group,
      },
      activity_providers: {
        name: 'Activity Providers',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        readOnly: true,
        fieldType: 'string'
      },
      transfer_providers: {
        name: 'Transfer Providers',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        readOnly: true,
        fieldType: 'string'
      },
      /* guides: {
        name: 'Guides',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
        readOnly: true,
        hide: true,
      },*/
      guide_reservations: {
        name: 'Guides',
        fieldRenderer: SetField.tableAdapter(userByRole('5')),
        slidePaneFieldRenderer: SPCustomSetFieldForGuideReservation.tableAdapter(
          userByRole('5')
        ),
        multiSwitchboard: true,
        url: userByRole('5').client.getAllPath,
        tempSchema: userByRole('5'),
        fieldType: 'guideReservation',
      },
      guide_wage: {
        name: 'Guide wage',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
      },
      group_size: {
        name: 'Size',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
      },
      address_from: {
        name: 'Meeting Place',
        fieldRenderer: SelectAddressField.tableAdapter(address),
        slidePaneFieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
        switchboard: true,
        url: address.client.getAllPath,
        tempSchema: address,
        fieldType: 'address',
      },
      address_to: {
        name: 'Venue',
        fieldRenderer: SelectField.tableAdapter(address),
        slidePaneFieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
        switchboard: true,
        url: address.client.getAllPath,
        tempSchema: address,
        fieldType: 'address',
      },
      staff: {
        name: 'Staff',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.user),
        multiSwitchboard: true,
        url: enumItems.user.client.getAllPath,
        tempSchema: enumItems.user,
        readOnly: true,
        fieldType: 'multiple-rows',
      },
      drivers: {
        name: 'Drivers',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        readOnly: true,
      },
      vehicles: {
        name: 'Vehicles',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        readOnly: true,
      },
      confirm_guide_file: {
        name: 'Confirm Guide File (SPA activity)',
        fieldRenderer: SingleFileField,
        slidePaneFieldRenderer: SingleFileField,
        fieldType: 'file',
      },
      original_price: {
        name: 'Original Price',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPListField,
        fieldType: 'costs',
        readOnly: true,
      },
      original_price_pp: {
        name: 'Original Price PP',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPListField,
        fieldType: 'costs',
        readOnly: true,
      },
      final_price: {
        name: 'Final Price',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'price',
      },
      final_price_pp: {
        name: 'Final Price PP',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'price',
      },
      total_costs: {
        name: 'Total Costs',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPListField,
        fieldType: 'costs',
        readOnly: true,
      },
      profit: {
        name: 'Profit',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPListField,
        fieldType: 'costs',
        readOnly: true,
      },
      notes: {
        name: 'Notes',
        fieldRenderer: RichTextField,
        slidePaneFieldRenderer: SPRichTextField,
        fieldType: 'editable-textarea',
      },
      free: {
        name: 'Free Activity',
        fieldRenderer: BooleanField,
        slidePaneFieldRenderer: SPBooleanField,
        fieldType: 'boolean',
      },
      refund: {
        name: 'Refund',
        fieldRenderer: BooleanField,
        slidePaneFieldRenderer: SPBooleanField,
        fieldType: 'boolean',
      },
      guide_bonus: {
        name: 'Guide Bonus',
        fieldRenderer: BooleanField,
        slidePaneFieldRenderer: SPBooleanField,
        fieldType: 'boolean',
      },
      user_added: {
        name: 'User Added',
        fieldRenderer: SelectField.tableAdapter(user),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(user),
        switchboard: true,
        readOnly: true,
        url: user.client.getAllPath,
        tempSchema: user,
      },
      date_added: {
        name: 'Date Added',
        fieldRenderer: DateField,
        slidePaneFieldRenderer: SPDateTimeField,
        fieldType: 'dateTime',
        readOnly: true,
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client(
      '/activity-reservations',
      forGroupId !== undefined
        ? `/groups/${forGroupId}/activity-reservations`
        : undefined
    ),
    viewTable: 'activity_reservations',
  };
};
